/**
 * Environment variables defined in .env[.*]
 */
import {Lang, Currency} from 'simpli-web-sdk'

export abstract class Env {
  static readonly BASE_URL = process.env.BASE_URL!

  static readonly APP_ENV = process.env.VUE_APP_ENV!

  static readonly API_URL = process.env.VUE_APP_API_URL!
  static readonly API_INTERNATIONAL_URL = process.env
    .VUE_APP_API_INTERNATIONAL_URL!
  static readonly SOCKET_URL = process.env.VUE_APP_SOCKET_URL!

  static readonly APP_NAME = process.env.VUE_APP_NAME!
  static readonly APP_LANG = process.env.VUE_APP_LANG! as Lang
  static readonly APP_CURRENCY = process.env.VUE_APP_CURRENCY! as Currency

  static readonly PRIMARY_COLOR = process.env.VUE_APP_PRIMARY_COLOR!
  static readonly SECONDARY_COLOR = process.env.VUE_APP_SECONDARY_COLOR!
  static readonly TERTIARY_COLOR = process.env.VUE_APP_TERTIARY_COLOR!
  static readonly SUCCESS_COLOR = process.env.VUE_APP_SUCCESS_COLOR!
  static readonly DANGER_COLOR = process.env.VUE_APP_DANGER_COLOR!

  static readonly SMALL_SCREEN = Number(process.env.VUE_APP_PRIMARY_COLOR!)
  static readonly MEDIUM_SCREEN = Number(process.env.VUE_APP_SECONDARY_COLOR!)
  static readonly LARGE_SCREEN = Number(process.env.VUE_APP_TERTIARY_COLOR!)
  static readonly EXTRA_LARGE_SCREEN = Number(
    process.env.VUE_APP_SUCCESS_COLOR!
  )

  /**
   * Blueprint of csv files
   * ```
   * [name_of_the_entity]: {
   *   [column_variable_name]: ['acceptable_names_in_csv_file', ...],
   *   ...
   * }
   * ```
   */
  static readonly CSV_BLUEPRINT = {
    removeCarga: {
      id: ['id', 'idCarga', 'ID', 'ID_CARGA', 'ID da Carga'],
    },
    removeCargo: {
      id: ['idCargo', 'ID_CARGO', 'ID Cargo'],
    },
    reprocessWebhook: {
      id: ['id', 'idCarga', 'ID', 'ID_CARGA', 'ID da Carga', 'Idcarga'],
    },
  }

  static readonly XLSX_BLUEPRINT = {
    CadastrarTracking: {
      cnpj: ['cnpj', 'CNPJ'],
      idOcorrenciaExterna: [
        'id externo',
        'Id Externo',
        'ID Externo',
        'id Externo',
        'id_externo',
        'ID_EXTERNO',
      ],
      descricao: [
        'descricao',
        'Descricao',
        'DESCRICAO',
        'descrição',
        'Descrição',
        'DESCRIÇÃO',
      ],
      ativo: ['Ativo', 'ativo', 'ATIVO'],
    },
  }
}
